import React from 'react';
import { Home, Mail, Phone } from 'lucide-react';

const Footer = () => {
  return (
    <footer className='bg-slate-900 text-white mt-24'>
      <div className='max-w-7xl mx-auto px-4 md:px-8 py-12'>
        <div className='grid grid-cols-1 md:grid-cols-3 gap-8'>
          {/* Logo & Description */}
          <div>
            <div className='flex items-center space-x-2 mb-4'>
              <Home className='w-8 h-8 text-primary' />
              <span className='text-2xl font-heading font-bold'>
                Propiedades<span className='text-primary'>CO</span>
              </span>
            </div>
            <p className='text-slate-400 text-sm'>
              Tu portal confiable para comprar y arrendar propiedades en
              Colombia. Encuentra el hogar de tus sueños.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className='font-heading font-bold text-lg mb-4'>
              Enlaces Rápidos
            </h3>
            <ul className='space-y-2 text-slate-400 text-sm'>
              <li>
                <a href='/' className='hover:text-white transition-colors'>
                  Inicio
                </a>
              </li>
              <li>
                <a
                  href='/buscar?operation=SALE'
                  className='hover:text-white transition-colors'
                >
                  Comprar
                </a>
              </li>
              <li>
                <a
                  href='/buscar?operation=RENT'
                  className='hover:text-white transition-colors'
                >
                  Arrendar
                </a>
              </li>
              <li>
                <a
                  href='/publicar-propiedad'
                  className='hover:text-white transition-colors'
                >
                  Publicar Propiedad
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className='font-heading font-bold text-lg mb-4'>Contacto</h3>
            <ul className='space-y-3 text-slate-400 text-sm'>
              <li className='flex items-center space-x-2'>
                <Mail className='w-4 h-4' />
                <span>info@propiedadesco.com</span>
              </li>
              <li className='flex items-center space-x-2'>
                <Phone className='w-4 h-4' />
                <span>+57 300 123 4567</span>
              </li>
            </ul>
          </div>
        </div>

        <div className='border-t border-slate-800 mt-8 pt-8 text-center text-slate-500 text-sm'>
          <p>© 2025 PropiedadesCO. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
